export type ServiceAuthorizationAmountType = 'money';

export interface ServiceAuthorizationListItem {
  service_authorization_id: string;
  activity_id: string;
  service_id: string;
  service_title: string;
  start_date: string;
  end_date: string;
  amount_type: ServiceAuthorizationAmountType;
  amount: number;
  usage: number;
  external_id?: string;
  external_usage: number;
  cap_count: number;
}

export interface ServiceAuthorizationCapListItem {
  service_authorization_cap_id: string;
  start_date: string;
  end_date: string;
  amount_type: ServiceAuthorizationAmountType;
  amount: number;
  approved_overage_amount: number;
  usage: number;
  external_id?: string;
  external_usage: number;
}

export const serviceAuthorizationLimits = {
  service_authorizations_count: 100,
  service_authorization_caps_count: 52,
  maxAmount: 1000000
};
